import { dealFormField } from '@openx/types/deal.ts';
import type { TFunction } from 'i18next';
import type { OpenXAgentToolData } from '../../../context/OpenXAgentContext.ts';

export const assembleContextAlertMessage = (t: TFunction, toolData: OpenXAgentToolData | null): string | null => {
  if (!toolData) return null;
  if (!('id' in toolData) || !toolData.id) return `${t('Context')}: ${t('Current targeting configuration')}`;

  const displayedId = (dealFormField.DEAL_ID in toolData && toolData.deal_id) || toolData.id;

  return `${t('Context')}: ${toolData.name} (ID: ${displayedId})`;
};
